import { Component, OnInit } from '@angular/core';

class model{
}

@Component({
	templateUrl: './bio.component.html',
	styleUrls: ['./bio.component.css']
})

export class BioComponent implements OnInit {
	public m: model;
	ngOnInit() {
		this.m = new model();
	}
}


// WEBPACK FOOTER //
// /home/nivedha/Documents/github/sandbox/src/sppu-beta/src/app/academics/bio.component.ts